module.exports = require("chrome-remote-interface");